import { type FC, memo } from "react";
import { type KeyValue, KeyValueTable } from "@/components/fragments/table/key-value-table";
import { type ApplicationFormValue } from "@/components/fragments/argyle";
import { shipmentTableLabelTestId, shipmentTableTestId } from "./const";
import { Box } from "@/components/essentials/box";
import { Typography } from "@/components/essentials/typography";
import { copyContractorToShipmentIfSelectSame } from "@/components/fragments/argyle/module";
import { getPrefectureName } from "@/modules/utils/prefecture";

export interface ShipmentTableProps {
  readonly value: ApplicationFormValue;
}

export const ShipmentTable: FC<ShipmentTableProps> = memo(({ value }) => {
  const {
    shippingAddress: {
      lastName,
      firstName,
      postalCode,
      phoneNumber,
      prefectureCode,
      address1,
      address2,
      buildingName,
      mail,
    },
  } = copyContractorToShipmentIfSelectSame(value);

  const shipmentKeyValueData: KeyValue[] = [
    {
      key: "お名前",
      value: `${lastName} ${firstName}`,
    },
    {
      key: "郵便番号",
      value: postalCode,
    },
    {
      key: "住所",
      value: getPrefectureName(Number(prefectureCode)) + address1 + address2 + buildingName,
    },
    {
      key: "電話番号",
      value: phoneNumber,
    },
    {
      key: "メールアドレス",
      value: mail,
    },
  ];

  return (
    <Box data-testid={shipmentTableTestId}>
      <Typography variant="display6" mb="4" data-testid={shipmentTableLabelTestId}>
        お届け先情報
      </Typography>
      <KeyValueTable data={shipmentKeyValueData} />
    </Box>
  );
});

ShipmentTable.displayName = "ShipmentTable";
